import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCheck, FiX, FiTrash } from "react-icons/fi";
import { Product } from '../../Platform/Common/types';

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_code: string;   // Role ID
  exp?: number;      // Expiration timestamp (optional)
}

const B2CProductManager = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");


  const [isAddingNew, setIsAddingNew] = useState(false);
  const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited
  const [newProduct, setNewProduct] = useState<Product | null>(null);


  // Fetch enrolled students when tenant ID is set
const fetchProducts = useCallback(async () => {
  try {
    const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
    const response = await axios.get(`${b2c_apiurl}/products`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('b2c_token')}`,
      },
    });
    setProducts(response.data);
  } catch (error) {
    console.error("Failed to load B2C Products", error);
  }
}, []);

useEffect(() => {
  fetchProducts();
}, [fetchProducts]);

  const handleDeleteProduct = async (product_id: number) => {
    // Placeholder function
       try {
         const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
       console.log("Printing Token from Delete" + localStorage.getItem("b2c_token"));
       await axios.delete(apiurl + `/product/${product_id}`, {
         headers: {
           Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
         }
       });
       fetchProducts();
       setEditRow(null); // Reset edit mode after successful update
       toast({ title: "B2C Product deleted successfully", status: "success" });
      } catch (err: any) {
          console.error(err);

              const message =
                err?.response?.data?.detail ||
                "Error deleting product";

              toast({
                title: message,
                status: "error",
              });
            }
          };

/*   const handleAddNewProduct = () => {
    setIsAddingNew(true);
    setNewProduct({ product_id: 0, name: '', description: '',  current_content_type:'PRACTICE_SET' , is_active: true, created_at: new Date(), updated_at: new Date()});
  }; */

  const handleRemoveNewProduct = () => {
    setIsAddingNew(false);
    setNewProduct(null);
  };
/* 
  const handleSaveProduct = async (product: Product) => {
    try {

        const payload = {
            name: product.name,
            description: product.description,
            current_content_type: product.current_content_type,
            is_active: product.is_active,
            created_at: product.created_at,
            updated_at: product.updated_at,
        };
      const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      
      console.log("printing product user payload",payload);

      const response = await axios.post(apiurl+`/create-product/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
        }
      });
      setProducts([...products, response.data]);
      setIsAddingNew(false);
      setNewProduct(null);
      toast({ title: "Product added successfully", status: "success" });
    } catch (error) {
      console.error("Failed to save Product ", error);
      toast({ title: "Failed to add Product ", status: "error" });
    }
  };

  const handleUpdateProduct = async (product: Product) => {
    try {
        

        const payload = {
            name: product.name,
            description: product.description,
            current_content_type: product.current_content_type,
            is_active: product.is_active,
            created_at: product.created_at,
            updated_at: product.updated_at,
        };
      const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
     
      console.log("Printing Token from Update" + localStorage.getItem("b2c_token"));
      await axios.put(apiurl+`/update-product/${product.product_id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
        }
      });
      fetchProducts();
      setEditRow(null); // Reset edit mode after successful update
      toast({ title: "Product updated successfully", status: "success" });
    } catch (err: any) {
    console.error(err);

        const message =
          err?.response?.data?.detail ||
          "Error updating product";

        toast({
          title: message,
          status: "error",
        });
      }
    };

  const handleEditRow = (user_id: number) => {
    setEditRow(user_id);
    setIsAddingNew(false); // Disable add tenant while editing
  }; */

  const handleCancelEdit = () => {
    setEditRow(null);
    setIsAddingNew(false);
  };

    const handleReviewProduct = (product_id: number) => {
     
      navigate(`/practice/app/b2c-product-manager/review-b2c-product/${product_id}`);
  
  };


  const handleAddNewProduct = () => {

    const product_id=0;

    navigate(`/practice/app/b2c-product-manager/review-b2c-product/${product_id}`);
  

  };


  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>B2C Product Manager</Heading>
      </VStack>
            <Box mt={4}>
               <Text fontWeight="bold">Existing B2C Products</Text>
        <Button  mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewProduct} isDisabled={isAddingNew || editRow !== null}>
          + B2C Product
        </Button>
      </Box>
      <Box mt={4}>
       
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Product Name</Th>
              <Th>Description</Th>
              <Th>Product Type</Th>
              <Th>Status</Th>
              {/* <Th>Created At</Th>
              <Th>Updated At</Th> */}
             
            <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">

            {products.map((product) => (
                <Tr
                key={product.product_id}
                opacity={editRow && editRow !== product.product_id ? 0.5 : isAddingNew ? 0.5 : 1}
                >
                <Td>{product.product_id}</Td>
                <Td>
                    {
                        product.name
                    }
                </Td>
                <Td>
                    {
                        product.description
                    }
                </Td>
                <Td>
                    {
                        product.current_content_type
                    }
                </Td>
                <Td>
                    { product.is_active ? (
                        "Active"
                        ) : (
                        "Inactive"
                        )}
                </Td>
                
                <Td>
                    {
                        <>
                    <Tooltip label="Edit">
                        <Button size="sm" onClick={() => handleReviewProduct(product.product_id)} mr={8}>
                        <FiEdit />
                        </Button>
                    </Tooltip>
                    <Tooltip label="Delete">
                    <Button
                            size="sm"
                            colorScheme="red"
                            onClick={() => {
                            if (window.confirm("Are you sure you want to delete this lesson?")) {
                                handleDeleteProduct(product.product_id);
                            }
                            }}
                        >
                            <FiTrash />
                        </Button>
                    </Tooltip>
                    </>
                    }
                </Td>
                </Tr>
            ))}

            </Tbody>

        </Table>
      </Box>

    </Box>
  );
};

export default B2CProductManager;
